import React from 'react';
import Translate from '../../../../../components/Translate';
import Switch from '../../../../../components-new/form/Switch';
import Tooltip from '../../../../../components-new/general/Tooltip';
import InfoIcon from '../../../../../assets/icons/InfoIcon';

const SilentModeSwitch = ({checked, onChange, hint}) => (
    <div className={`chat-action-modal__silent-mode ${checked ? 'is-active' : ''}`}>
        <Switch
            checked={checked}
            onChange={onChange}
            label={<Translate text="silentMode"/>}
        />
        <Tooltip text={hint} style={{display: 'flex'}}>
            <span className="chat-action-modal__silent-mode-info" tabIndex={0}>
                <InfoIcon width={16} height={16} stroke="currentColor"/>
            </span>
        </Tooltip>
    </div>
);

export default SilentModeSwitch;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/SilentModeSwitch.jsx